import React from 'react';
import { Mail, Phone, MapPin, Terminal, Github } from 'lucide-react';

const Contact = ({ data, language, translations }) => {
  const profileData = data || JSON.parse(localStorage.getItem('portfolioData') || '{}');
  const t = translations || { contact: 'Contacto' };

  return (
    <div className="content-section">
      <h2 className="section-title">{t.contact}</h2>
      <div className="section-content">
        <p style={{ marginBottom: '30px', color: 'var(--text-secondary)', lineHeight: '1.8' }}>
          {language === 'en' 
            ? 'Interested in collaborating or have any questions? Feel free to contact me through any of these channels.'
            : '¿Interesado en colaborar o tienes alguna pregunta? No dudes en contactarme a través de cualquiera de estos medios.'}
        </p>

        <div className="contact-grid">
          <div className="contact-item">
            <Mail className="contact-icon" />
            <div className="contact-info">
              <h3>Email</h3>
              <p>{profileData.email}</p>
            </div>
          </div>

          <div className="contact-item">
            <MapPin className="contact-icon" />
            <div className="contact-info">
              <h3>{language === 'en' ? 'Location' : 'Ubicación'}</h3>
              <p>{t.location || profileData.location}</p>
            </div>
          </div>

          <div 
            className="contact-item" 
            onClick={() => window.open(profileData.github, '_blank')}
            style={{ cursor: 'pointer' }}
          >
            <Github className="contact-icon" />
            <div className="contact-info">
              <h3>GitHub</h3>
              <p>{profileData.githubUsername}</p>
            </div>
          </div>
        </div>

        <div style={{ 
          marginTop: '40px', 
          padding: '30px', 
          background: 'var(--bg-tertiary)', 
          borderRadius: '8px',
          border: '1px solid var(--border-color)',
          textAlign: 'center'
        }}>
          <Terminal size={40} color="var(--steel-dim)" style={{ margin: '0 auto 20px' }} />
          <h3 style={{ color: 'var(--steel-bright)', marginBottom: '15px', fontSize: '20px' }}>
            {language === 'en' ? 'Ready to collaborate?' : '¿Listo para colaborar?'}
          </h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
            {language === 'en' 
              ? 'I am open to new opportunities in software development and cybersecurity. Send me a message and let\'s talk about how we can work together.'
              : 'Estoy abierto a nuevas oportunidades en desarrollo de software y ciberseguridad. Envíame un mensaje y hablemos sobre cómo podemos trabajar juntos.'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
